import Jimp from 'jimp/es';

export const removeBackground = async (image: Jimp) => {
  // https://github.com/oliver-moran/jimp/issues/395#issuecomment-371512278
  const threshold = 32;

  image.scan(
    0,
    0,
    image.bitmap.width,
    image.bitmap.height,
    (_x: number, _y: number, idx: number) => {
      const r: number = image.bitmap.data[idx + 0]!;
      const g: number = image.bitmap.data[idx + 1]!;
      const b: number = image.bitmap.data[idx + 2]!;

      if (r + threshold >= 255 && g + threshold >= 255 && b + threshold >= 255) {
        image.bitmap.data[idx + 0] = r;
        image.bitmap.data[idx + 1] = g;
        image.bitmap.data[idx + 2] = b;
        image.bitmap.data[idx + 3] = 0;
      }
    },
  );

  // Update the image.bitmap data
  const buffer = await image.getBufferAsync(Jimp.MIME_PNG);
  const transformedImage = await Jimp.read(buffer);

  return transformedImage;
};
